'use strict';

export class Vipprofilepromo {
    constructor(component_key) {
        this.id = component_key;
        this.$root = jQuery(`.js-${this.id}`);
        if (!this.$root.length) return;

        this.$mainSlider = this.$root.find('.js-main-slider');
        this.$slides = this.$root.find('.js-main-slide');
        this.$dots = this.$root.find('[data-slide]');
        this.currentIndex = 0;
        this.timer = null;
        this.autoSlideInterval = 5000;
        this.$infoOverlay = this.$root.find(`.js-${this.id}_dialog`);
		this.updateUI();
    }

    init() {
        this.addEvents();
        this.startAutoSlide();
    }

    startAutoSlide() {
        this.stopAutoSlide();
        this.timer = setInterval(() => {
            this.next();
        }, this.autoSlideInterval);
    }

    stopAutoSlide() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    addEvents() {
        this.$dots.on('click', (e) => {
            const index = jQuery(e.currentTarget).data('slide');
            this.goTo(index);
        });
        
        this.$infoOverlay.on('click', () => {
            jQuery('html').addClass('js-no_scroll');
            jQuery(`.js-dialog_infoicon`).appendTo('body');
            yalwa.v.component_instances['dialog_infoicon'].show();
            
            const slide_options = {
                css_prefix:'infocard__',
                timeout:7000,
                container_class: 'js-simple_auto_slide_vipinfo',
                bullets : {container_class:  'js-slider_vipinfo_pagination_container'},
                clickable : false,
            };
            this.pf_info_slider = new yalwa.basics.simple_auto_slide(slide_options);
            this.pf_info_slider.start();
            
            //Mobile
            if (window.innerWidth <= 765) {
                jQuery('.js-slider_vipinfo_pagination_container').appendTo('.js-pagination_header');
            }
        });

        this.$root.on('mouseenter', () => this.stopAutoSlide());
        this.$root.on('mouseleave', () => this.startAutoSlide());

        // Mobile Swipe Logic
        let startX = 0;
        this.$root.on('touchstart', (e) => {
            this.stopAutoSlide();
            startX = e.touches[0].clientX;
        });
        this.$root.on('touchend', (e) => {
            const endX = e.changedTouches[0].clientX;
            if (startX - endX > 50) this.next();
            else if (endX - startX > 50) this.prev();
            
            this.startAutoSlide();
        });
    }

    goTo(index) {
        this.currentIndex = index;
        this.updateUI();
    }

    updateUI() {
        const offset = this.currentIndex * -100;
        this.$mainSlider.css('transform', `translateX(${offset}%)`);

        // Sync all dots (both mobile and desktop groups)
        this.$dots.removeClass('is-active');
        this.$root.find(`[data-slide="${this.currentIndex}"]`).addClass('is-active');
    }

    next() {
        const nextIdx = (this.currentIndex + 1) % this.$slides.length;
        this.goTo(nextIdx);
    }

    prev() {
        const prevIdx = (this.currentIndex - 1 + this.$slides.length) % this.$slides.length;
        this.goTo(prevIdx);
    }
}

// Assets Loader initialization
Object.keys(yalwa.v.components).forEach(key => {
    if (key.startsWith('vipprofilepromo')) {
        new Vipprofilepromo(key).init();
    }
});